import { useQuery } from '@tanstack/react-query';

import { getEmojiEditions } from './request';

export type EmojiEditionsReturn = ReturnType<typeof useEmojiEditions>;

function getQueryKey(id?: string) {
    return ['emoji-editions', id ?? 'query-key'];
}

export function useEmojiEditions() {
    const { data, error, status, isFetched, isFetching } = useQuery({
        queryKey: getQueryKey(),
        queryFn: ({ signal }) => getEmojiEditions({ settings: { signal } }),
        retry: false,
        enabled: true,
    });

    return {
        editions: data,
        error,
        status,
        fetched: isFetched,
        fetching: isFetching,
    };
}
